// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layer {
  padding: 8px;
  border-style: solid;
  border-width: 1px;
  border-color: rgb(195, 195, 195);
  display: flex;
  flex-direction: column;
  /* background-color: #e3e3e3; */
  margin-bottom: 8px;
  border-radius: 8px;

  .layerBar {
    display: flex;
    overflow-x: auto;  /* Added: Horizontal scroll if overflow */

    h4 {
      font-size: 20px;
      font-weight: 700;
      display: inline-flex;
      flex-grow: 1;
      padding: 4px 0px 0px 16px;
      color: rgb(53, 48, 48);
      /* */
      max-width: 100%; /* Fills parent, but caps at full width */
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    button {
      display: inline-block;
      /* margin-left: 8px; */  /* Optional: Remove if using gap below */
    }

    .controls {
      display: flex;         /* Added: Flex for buttons */
      flex-wrap: nowrap;     /* Added: No wrapping */
      align-items: center;   /* Added: Optional vertical centering */
      gap: 8px;              /* Added: Spacing between buttons */

      button {
        /* margin-left: 8px; */  /* Optional: Remove if using gap */
        min-width: 40px;       /* Added: Optional, prevents squishing */
      }
    }
  }
}

.layers {
  border-width: 0;
  border-color: rgb(195, 195, 195);
  margin-top: 8px;
}

.closed {
  display: none;
}

.layerType {
  padding: 8px 0px 8px 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/layer/layer.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;;EAElB;IACE,aAAa;IACb,gBAAgB,GAAG,yCAAyC;;IAE5D;MACE,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,YAAY;MACZ,yBAAyB;MACzB,sBAAsB;MACtB,IAAI;MACJ,eAAe,EAAE,yCAAyC;MAC1D,gBAAgB;MAChB,uBAAuB;MACvB,mBAAmB;IACrB;;IAEA;MACE,qBAAqB;MACrB,sBAAsB,GAAG,wCAAwC;IACnE;;IAEA;MACE,aAAa,UAAU,4BAA4B;MACnD,iBAAiB,MAAM,uBAAuB;MAC9C,mBAAmB,IAAI,uCAAuC;MAC9D,QAAQ,eAAe,mCAAmC;;MAE1D;QACE,sBAAsB,GAAG,kCAAkC;QAC3D,eAAe,QAAQ,wCAAwC;MACjE;IACF;EACF;AACF;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".layer {\n  padding: 8px;\n  border-style: solid;\n  border-width: 1px;\n  border-color: rgb(195, 195, 195);\n  display: flex;\n  flex-direction: column;\n  /* background-color: #e3e3e3; */\n  margin-bottom: 8px;\n  border-radius: 8px;\n\n  .layerBar {\n    display: flex;\n    overflow-x: auto;  /* Added: Horizontal scroll if overflow */\n\n    h4 {\n      font-size: 20px;\n      font-weight: 700;\n      display: inline-flex;\n      flex-grow: 1;\n      padding: 4px 0px 0px 16px;\n      color: rgb(53, 48, 48);\n      /* */\n      max-width: 100%; /* Fills parent, but caps at full width */\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    button {\n      display: inline-block;\n      /* margin-left: 8px; */  /* Optional: Remove if using gap below */\n    }\n\n    .controls {\n      display: flex;         /* Added: Flex for buttons */\n      flex-wrap: nowrap;     /* Added: No wrapping */\n      align-items: center;   /* Added: Optional vertical centering */\n      gap: 8px;              /* Added: Spacing between buttons */\n\n      button {\n        /* margin-left: 8px; */  /* Optional: Remove if using gap */\n        min-width: 40px;       /* Added: Optional, prevents squishing */\n      }\n    }\n  }\n}\n\n.layers {\n  border-width: 0;\n  border-color: rgb(195, 195, 195);\n  margin-top: 8px;\n}\n\n.closed {\n  display: none;\n}\n\n.layerType {\n  padding: 8px 0px 8px 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
